var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImagePlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 32,
    viewBox: "0 0 42 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.0625 32H3.9375C1.72266 32 0 30.2773 0 28.0625V4.4375C0 2.30469 1.72266 0.5 3.9375 0.5H38.0625C40.1953 0.5 42 2.30469 42 4.4375V28.0625C42 30.2773 40.1953 32 38.0625 32ZM9.1875 5.09375C6.64453 5.09375 4.59375 7.22656 4.59375 9.6875C4.59375 12.2305 6.64453 14.2812 9.1875 14.2812C11.6484 14.2812 13.7812 12.2305 13.7812 9.6875C13.7812 7.22656 11.6484 5.09375 9.1875 5.09375ZM5.25 26.75H36.75V17.5625L29.5312 10.4258C29.1211 10.0156 28.5469 10.0156 28.1367 10.4258L17.0625 21.5L12.4688 16.9883C12.0586 16.5781 11.4844 16.5781 11.0742 16.9883L5.25 22.8125V26.75Z",
    fill: "#F6F6F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePlaceholder);
export default __webpack_public_path__ + "static/media/image-placeholder.0fd8b0a0db60d09727eb5a6e93fab7d8.svg";
export { ForwardRef as ReactComponent };